import lng from '@lightningjs/core';
import { Colors, Utils } from '@lightningjs/sdk';
import { Row } from '@lightningjs/ui-components';
import Button from './components/Button';
import AuthRoute from '../../../components/layouts/AuthRoute/AuthRoute';

export const SignOutOptions = [
  { id: 1, title: 'No, resume' },
  { id: 2, title: 'Yes, sign out' },
];

export default class SignOut extends AuthRoute {
  static _template() {
    return {
      ...super._template(),
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('#000000').get(),
      alpha: 0.9,
      Logo: {
        x: 740,
        y: 310,
        texture: lng.Tools.getSvgTexture(Utils.asset('/images/logo.png'), 438, 68),
      },
      Text: {
        y: 445,
        x: 640,
        text: {
          text: 'Are you sure you want to sign out?',
          fontFace: 'OpenSans-Regular',
          color: Colors('#fafafa').get(),
        },
      },
      Row: {
        type: Row,
        y: 600,
        x: 715,
        collision: true,
        items: SignOutOptions.map((option, index) => ({
          index,
          collision: true,
          type: Button,
          option,
          color: Colors('#292929').get(),
        })),
      },
    };
  }

  $setIndex(index) {
    this._Row.selectedIndex = index;
  }

  get _Row() {
    return this.tag('Row');
  }

  _getFocused() {
    return this._Row;
  }
}
